import { useEffectOnce } from 'usehooks-ts'
import { fetchStaticContractsAction } from './actions'
import { useAppDispatch } from '../index'

export function Web3Updater() {
  const dispatch = useAppDispatch()
  // fetch multicall contract addresses, use to merge token balances requests.

  return null
}
